// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAqO10T4fHvX-BOcXI5BiHVc5khlE-7XI4",
  authDomain: "chatting-8ef8f.firebaseapp.com",
  projectId: "chatting-8ef8f",
  storageBucket: "chatting-8ef8f.appspot.com",
  messagingSenderId: "1064318736401",
  appId: "1:1064318736401:web:2df4dc908b518ec9a1f9b0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default firebaseConfig